(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const togglers = document.querySelectorAll('[data-toggle="collapse"]');

    togglers.forEach(function(toggler) {
      toggler.addEventListener('click', function() {
        const targetSelector = this.getAttribute('data-target');
        const target = document.querySelector(targetSelector);

        if (target) {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';

          // Toggle classes
          this.classList.toggle('collapsed');
          target.classList.toggle('show');

          // Update aria-expanded
          this.setAttribute('aria-expanded', !isExpanded);
        }
      });
    });
  });
})();
